import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    helpIconInline: {
      fontSize: '1.0rem',
      color: theme.palette.primary.main,
      marginLeft: 5,
    },
    tooltip: {
      maxWidth: 250,
    },
    tableContainer: {
      overflow: 'auto',
      '&::-webkit-scrollbar': {
        '-webkit-appearance': 'none !important',
        width: '7px !important',
        height: '7px !important',
      },
      '&::-webkit-scrollbar-thumb': {
        borderRadius: '4px !important',
        backgroundColor: 'rgba(0, 0, 0, .5) !important',
        boxShadow: '0 0 1px rgba(255, 255, 255, .5) !important',
      },
    },
  };
});

const customCardStyles = makeStyles((theme) => {
  return {
    root: {},
  };
});

export { useStyles, customCardStyles };
